import { dollars } from '~/lib/formatters';

import TwoLineMenuItem from './TwoLineMenuItem';

const HubspotDealMenuItem = ({ deal, owner }) => (
  <TwoLineMenuItem
    href={`https://app.hubspot.com/contacts/${deal.hubspotCompany?.externalAccountId}/deal/${deal['id']}`}
    externalLinkClass="text-hubspot"
    title={deal.name}
    subtitle={
      <>
        {owner && <>Owned by {owner?.ownerName || 'Unknown Owner'}</>}
        <>{deal.amount && <> &mdash; {dollars(deal.amount)}</>}</>
      </>
    }
  />
);

export default HubspotDealMenuItem;
